import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { recordicon, serachicongrey } from "./threadsvg";
import { showToast } from "../../../../reduxtoolkit/toastslice";
import api from "../../../../api/api";

const NewThreadModal = ({ open, fetchdata, onClose, data, users }) => {
  const [activityText, setActivityText] = useState("");
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(false);
const [subject,setSubject]=useState('')
const [isRecording, setIsRecording] = useState(false);
const [isTranscribing, setIsTranscribing] = useState(false);
const [searchQuery, setSearchQuery] = useState("");
const [showMention, setShowMention] = useState(false);
const [taggedUsers, setTaggedUsers] = useState([]);
const mediaRecorderRef = useRef(null);
const audioChunksRef = useRef([]);
  const dispatch = useDispatch();
  const userConfig = useSelector((state) => state.userconfig);
  const practiseid = window.getPracticeId();

  const taggableList = (users || []).map((u) => ({
    id: u.id,
    name: `${u.firstname} ${u.lastname}`.trim(),
    type: u.role || "User",
  }));

  const filteredSearchResults = searchQuery
    ? taggableList.filter((item) => item.name.toLowerCase().includes(searchQuery.toLowerCase()))
    : [];

  const mentionMatch = activityText.match(/@([\w\s.]*)$/);
  const mentionQuery = mentionMatch ? mentionMatch[1].trim().toLowerCase() : "";
  const filteredMentionResults = mentionQuery
    ? taggableList.filter((item) => item.name.toLowerCase().includes(mentionQuery))
    : [];

  if (!open) return null;

  const categories = [
    "Urgent",
    "Labs",
    "Rx Refill",
    "Referral",
    "Callback",
    "Insurance",
    "Administrative",
  ];
const resetForm = () => {
  setActivityText("");
  setCategory("");
  setSubject('');
  setIsRecording(false);
  setIsTranscribing(false);
  setTaggedUsers([]);
};
const handleCategoryClick = (cat) => {
  setCategory((prev) =>
    prev.includes(cat)
      ? prev.filter((c) => c !== cat) // remove
      : [...prev, cat] // add
  );
};
const startRecording = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mediaRecorder = new MediaRecorder(stream);
    mediaRecorderRef.current = mediaRecorder;
    audioChunksRef.current = [];

    mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) audioChunksRef.current.push(event.data);
    };

    mediaRecorder.onstop = async () => {
      const audioBlob = new Blob(audioChunksRef.current, { type: "audio/webm" });
      setIsTranscribing(true);
      try {
        const formData = new FormData();
        const randomString = `audio_${Math.random().toString(36).substring(2, 15)}.webm`;
        formData.append("audio_file", audioBlob, randomString);

        const response = await api.post(
          `/v1/${practiseid}/messaging/speech_to_text`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        setActivityText((prev) => prev + (response?.text || ""));
      } catch (error) {
        console.error("Error calling transcription API:", error);
      } finally {
        setIsTranscribing(false);
        stream.getTracks().forEach((track) => track.stop());
      }
    };

    mediaRecorder.start();
    setIsRecording(true);
  } catch (error) {
    console.error("Error accessing audio devices:", error);
  }
};

const stopRecording = () => {
  if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
    mediaRecorderRef.current.stop();
    setIsRecording(false);
  }
};

  const handleCreate = async () => {
 if (!activityText) return;

    try {
      setLoading(true);

      const payload = {
        sender_id: userConfig.id,
        activity_text: activityText,
        category: Array.isArray(category) ? category.map(c => c.replace(/\s+/g, "")).join(",") : "",
        status: "Open",
        non_visit_note_id: 0,
        subject: subject,
        recipient_id: taggedUsers.length > 0 ? taggedUsers[0].id : null,
      };

      const response = await api.post(
        `/v1/${practiseid}/patient/${data.patientid}/nonvisitnotes`,
        payload
      );

      if (response.status === 200) {
        dispatch(
          showToast({
            message: "Thread Added successfully",
            severity: "success",
          })
        );

  resetForm();  
    
  fetchdata({ skipLoader: true });
        onClose();
      } else {
        dispatch(
          showToast({
            message: response?.message || "Something Went Wrong",
            severity: "info",
          })
        );
      }
    } catch (error) {
      console.log(error);
      dispatch(
        showToast({
          message: "Something Went Wrong",
          severity: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="bg-white w-full max-w-2xl rounded-2xl shadow-xl p-6">

        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-[#1D2951]">
            New Thread
          </h2>

          <div className="relative">
            <div className="flex items-center w-[250px] bg-[#F9FAFB] border border-[#E5E7EB] rounded-xl px-3 py-2">
              <span className="mr-2 flex-shrink-0">
                {serachicongrey}
              </span>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search & tag users"
                className="w-full bg-transparent outline-none text-sm"
              />
            </div>
            {searchQuery && filteredSearchResults.length > 0 && (
              <div className="absolute top-full left-0 mt-1 w-[250px] bg-white border rounded-lg shadow-md max-h-40 overflow-y-auto z-50">
                {filteredSearchResults.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => {
                      setActivityText((prev) => prev + `@${item.name} `);
                      setSearchQuery("");
                      setTaggedUsers((prev) => {
                        if (prev.some((u) => u.id === item.id)) return prev;
                        return [...prev, item];
                      });
                    }}
                    className="px-3 py-2 text-start hover:bg-gray-100 cursor-pointer text-sm flex justify-between items-center"
                  >
                    <span>{item.name}</span>
                    <span className="text-[10px] text-gray-400">{item.type}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <hr className="mb-4 border-gray-200" />

        {/* Patient Name */}
        <div className="mb-4 text-start">
          <label className="text-sm font-semibold text-[#1D2951]">
            Patient Name or Subject
          </label>
          <input
            type="text"
                    value={subject}
              onChange={(e) => setSubject(e.target.value)}
            className="mt-1 w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none"
          />
        </div>

        {/* Category */}
        <div className="mb-4 text-start">
          <label className="text-sm font-semibold text-[#1D2951]">
            Category
          </label>

          <div className="flex flex-wrap gap-2 mt-2">
            {categories.map((cat) => (
              <button
                key={cat}
    onClick={() => handleCategoryClick(cat)}
            className={`px-3 py-1 text-sm rounded-md border transition-all
  ${
    category.includes(cat)
      ? "bg-[#E17954] text-white border-[#E17954] shadow-md scale-105"
      : "border-gray-200 bg-gray-50 text-gray-700"
  }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Initial Note */}
        <div className="mb-4 text-start">
          <label className="text-sm font-semibold text-[#1D2951]">
            Initial Note
          </label>

          <div className="flex gap-4">
            <div className="relative mt-1 w-full">
              <textarea
                value={activityText}
                onChange={(e) => {
                  const value = e.target.value;
                  setActivityText(value);
                  setShowMention(/@\w*$/.test(value));
                }}
                placeholder="Describe the issue or reason for this thread..."
                className="w-full h-32 border border-gray-200 rounded-xl bg-[#F9FAFB] px-3 py-2 text-sm outline-none resize-none"
              />
              {showMention && filteredMentionResults.length > 0 && (
                <div className="absolute bottom-full left-0 mb-1 w-52 bg-white border rounded-lg shadow-md max-h-40 overflow-y-auto z-50">
                  {filteredMentionResults.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => {
                        const newText = activityText.replace(/@[\w\s.]*$/, `@${item.name} `);
                        setActivityText(newText);
                        setShowMention(false);
                        setTaggedUsers((prev) => {
                          if (prev.some((u) => u.id === item.id)) return prev;
                          return [...prev, item];
                        });
                      }}
                      className="px-3 py-2 text-start hover:bg-gray-100 cursor-pointer text-sm flex justify-between items-center"
                    >
                      <span>{item.name}</span>
                      <span className="text-[10px] text-gray-400">{item.type}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="flex flex-col items-center cursor-pointer" onClick={isRecording ? stopRecording : startRecording}>
              <div className={`w-12 h-12 ${isRecording ? "bg-red-600 animate-pulse" : isTranscribing ? "bg-yellow-500" : "bg-red-500"} rounded-full flex items-center justify-center text-white`}>
                {isTranscribing ? (
                  <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                ) : (
                  recordicon
                )}
              </div>
              <span className="text-[10px] text-gray-400 mt-1">
                {isRecording ? "Stop" : isTranscribing ? "Transcribing..." : "Record"}
              </span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-4 py-2 rounded-lg border border-gray-200 text-gray-600"
          >
            Cancel
          </button>

          <button
            onClick={handleCreate}
        disabled={loading || !activityText}
            className={`px-4 py-2 rounded-lg text-white flex items-center gap-2
              ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#E17954]"
              }`}
          >
            {loading && (
              <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
            )}
            {loading ? "Creating..." : "Create Thread"}
          </button>
        </div>

      </div>
    </div>
  );
};

export default NewThreadModal;